export default __webpack_public_path__ + "static/media/HSQ-logo.06518b0b.svg";